import { getApiUrl } from 'src/shared/utils/get-api-url';
import { mockRequest } from 'src/shared/api/utils/mock-request';

import { baseApi } from '../base-api';

import type { IGetAgreementsResponse, IGetLastAgreementResponse } from './types';

const isStubEnabled = import.meta.env.VITE_AGREEMENT_API_STUB === 'true';

const api = baseApi.extend({
  prefixUrl: `${getApiUrl(2)}/Agreement/`,
});

export const apiAgreement = {
  getLastAgreement: async () => await api.get<IGetLastAgreementResponse>('').json(),
  getAgreements: async () => await api.get<IGetAgreementsResponse[]>('Agrements').json(),
  getRequisite: async () => await api.get<string>('req').json(),
  checkIsAgreementAgreed: async () => {
    if (isStubEnabled) {
      return await mockRequest(true);
    }

    return await api.get<boolean>(`isAgreed`).json();
  },
  agreedingAgreement: async (agreementId: string) => {
    if (isStubEnabled) {
      return await mockRequest(true);
    }

    return await api.post(`Agreeding`, { json: { agreementId } }).json();
  },
};
